// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"7eebfad2","198":"8dd92add","747":"5b1973b5","974":"ae1cfb5d"}[chunkId] + ".chunk.css";
};